/**
 * Shared file-size cap for public claim-lodgement uploads.
 *
 * Single source of truth used by:
 *   - the server-side presign cap (`content-length-range` on the presigned POST,
 *     resolved from the `claimLodgement` upload purpose) — the authoritative control;
 *   - the public claim submit schema guard (`publicClaimInputSchema.files[].size`);
 *   - the client-side pre-check (`QuestionnaireUploadControl` `beforeUpload`) for fast UX.
 *
 * 25 MB mirrors the email-attachment cap (`EMAIL_SETTINGS.MAX_ATTACHMENT_SIZE_IN_BYTES`),
 * since lodged claim documents are frequently forwarded by email. Full-size phone photos
 * (~3–12 MB) sit comfortably below it; the cap mainly bounds documents on a public surface.
 */
export const MAX_CLAIM_LODGEMENT_FILE_BYTES = 25 * 1024 * 1024;
